export default "__VITE_ASSET__7485ebb7__"